module.exports = __webpack_public_path__ + "static/media/Amaranth-Bold.bf0816ca.ttf";